import { Checkout } from './Checkout'
import { CashCheckoutFinish } from './CashCheckoutFinish'
import { CheckoutFinish } from './CheckoutFinish'

export const Cards = {
  Checkout,
  CashCheckoutFinish,
  CheckoutFinish,
}
